import HtmlMessage from './htmlMessage.view';

export default HtmlMessage;
